import { jsx as _jsx } from "react/jsx-runtime";
import { useApp } from "./store";
import UploadScreen from "./components/UploadScreen";
import EditorScreen from "./components/EditorScreen";
export default function App() {
    const screen = useApp((s) => s.screen);
    return (_jsx("div", { className: "app-root", children: screen === "upload" ? _jsx(UploadScreen, {}) : _jsx(EditorScreen, {}) }));
}
